// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2UPkp","comment":"styles_comment__3goFs"};